function highlightGlossaryTermFromHash() {
    const id = window.location.hash?.substring(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });

        target.classList.add("glossary-highlight");
        setTimeout(() => {
            target.classList.remove("glossary-highlight");
        }, 1500);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    highlightGlossaryTermFromHash();

    document.querySelectorAll('a[href^="#glossary-"]').forEach(link => {
        link.addEventListener("click", e => {
            const targetId = link.getAttribute("href").substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                e.preventDefault();
                history.replaceState(null, null, `#${targetId}`);
                target.scrollIntoView({ behavior: "smooth", block: "start" });
                target.classList.add("glossary-highlight");
                setTimeout(() => target.classList.remove("glossary-highlight"), 1500);
            }
        });
    });
});

window.addEventListener("hashchange", highlightGlossaryTermFromHash);
